import { Flex } from "@gravity-ui/uikit";
import { ProductDetailResponseDto } from "definitions/product-storage";
import { DontHaveSubscribeBlock } from "src/widgets";

import { ProductModalContent } from "./ProductModalContent";
import { ProductModalContentSkeleton } from "./ProductModalContentSkeleton";

interface ProductContentWithPaymentProps {
  isLoading?: boolean;
  product?: ProductDetailResponseDto | null;
  hasMoney?: boolean;
  hasSubscribe?: boolean;
}

export const ProductContentWithPayment = ({
  isLoading,
  product,
  hasMoney,
  hasSubscribe,
}: ProductContentWithPaymentProps) => {
  if (isLoading) {
    return <ProductModalContentSkeleton />;
  }

  if (!product) {
    return <DontHaveSubscribeBlock />;
  }

  return (
    <Flex direction="column" gap="5">
      <ProductModalContent
        product={product}
        hasMoney={hasMoney}
        hasSubscribe={hasSubscribe}
      />
    </Flex>
  );
};
